import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc9d718"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "spinner"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bounce1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bounce2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bounce3" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

import { computed } from "vue";
import { BUTTONTYPE } from "./Button.types";
import { useProfileStore } from "@/store/Profile";


export default /*#__PURE__*/_defineComponent({
  props: {
  type: { type: String },
  fullWidth: Boolean,
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  adjusted: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props

const profileStore = useProfileStore();

const isButtonDisabled = computed(() => {
  return !profileStore.isConnected || props.disabled;
});



const width = props.fullWidth ? `w-full` : ``;

const baseStyle = "rounded px-4 py-2 font-black disabled:pointer-events-none disabled:opacity-50";
const secondaryStyle = `bg-light2 text-white`;

const typeStyle = computed(() => {
  return props.type === BUTTONTYPE.PRIMARY ? primaryStyle.value : secondaryStyle;
});

const primaryStyle = computed(() => {
  const shadow = props.adjusted ? "shadow-adjusted" : "shadow-standard";
  return `text-black mix-blend-screen bg-white ${shadow}`;
});

const buttonStyle = computed(() => {
  return `${baseStyle} ${typeStyle.value} ${width}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_unref(buttonStyle)),
    disabled: _unref(isButtonDisabled)
  }, [
    (!props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
  ], 10, _hoisted_1))
}
}

})